import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { FirebaseAwareService } from '../shared/firestore/firebase-aware.service';

export interface SendAdminTestEmailResult {
  ok: true;
  to: string;
  messageId?: string;
  appOrigin: string;
}

export interface SendAdminTestPushResult {
  ok: true;
  sentCount: number;
  adminCount: number;
  skippedNoToken: number;
}

@Injectable({ providedIn: 'root' })
export class AdminEmailService extends FirebaseAwareService {
  private readonly functions = inject(Functions);

  sendTestEmail(to?: string): Promise<SendAdminTestEmailResult> {
    const call = this.inCtx(() =>
      httpsCallable<{ to?: string }, SendAdminTestEmailResult>(
        this.functions,
        'sendAdminTestEmail',
      ),
    );
    return call(to?.trim() ? { to: to.trim() } : {}).then(res => res.data);
  }

  sendTestPush(): Promise<SendAdminTestPushResult> {
    const call = this.inCtx(() =>
      httpsCallable<Record<string, never>, SendAdminTestPushResult>(
        this.functions,
        'sendAdminTestPush',
      ),
    );
    return call({}).then(res => res.data);
  }
}
